// SYNC: This file is intentionally duplicated from
// invitecloudFrontend/src/modules/components/BrandLogo.tsx
// Any change here MUST be mirrored there and vice versa.
// Long-term: extract to packages/ui.

import React, { useState } from 'react';
import { Link } from 'react-router-dom';

export type LogoVariant = 'full' | 'icon';
export type LogoSize = 'sm' | 'md' | 'lg' | 'xl';

export interface BrandLogoProps {
  variant?: LogoVariant;
  size?: LogoSize;
  className?: string;
  href?: string;
}

const sizeMap: Record<LogoSize, string> = {
  sm: 'h-6',     // 24px
  md: 'h-8',     // 32px
  lg: 'h-14',    // 56px
  xl: 'h-20',    // 80px
};

export function BrandLogo({
  variant = 'full',
  size = 'md',
  className = '',
  href = '/',
}: BrandLogoProps) {
  const [imageError, setImageError] = useState(false);
  const logoSrc = '/assets/invitecloud-logo.png';
  const iconSrc = '/assets/ic-monogram.png';
  const src = variant === 'icon' ? iconSrc : logoSrc;
  const sizeClass = sizeMap[size];

  const img = (
    <img
      src={src}
      alt="InviteCloud"
      onError={() => setImageError(true)}
      className={`${sizeClass} w-auto ${className}`}
    />
  );

  if (imageError) {
    return (
      <div className={`${sizeClass} w-auto bg-primary/10 rounded-md flex items-center justify-center text-primary font-bold text-xs`}>
        IC
      </div>
    );
  }

  return href ? (
    <Link to={href} className="hover:opacity-80 transition-opacity flex items-center">
      {img}
    </Link>
  ) : (
    img
  );
}
